import Reports from '@/pages/reports/Reports.page'
import { createUserSettingsOptions } from '@/services/setting/setting.options';
import DashboardLayout from '@/layouts/DashboardLayout'
import { createUserQueryOptions } from '@/services/auth/auth.options';
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/reports')({
  component: () => <ReportsLayout />,
  loader: async ({ context }) => {
    const user = await context?.queryClient?.fetchQuery(createUserQueryOptions({ ticketid: 0, customerid: 0, limittocustomer: false, auth: context?.auth }))
    await Promise.all([
      context?.queryClient?.ensureQueryData(createUserSettingsOptions(user?.ContextUser?.AgentId)),
    ])
  },
})

const ReportsLayout = () => {
  return (
    <DashboardLayout>
      <Reports />
      <Outlet />
    </DashboardLayout>
  )
}
